import AuthenticationPage from 'pages/AuthenticationPage';
import PostsPage from 'pages/PostsPage';
import AddPostPage from 'pages/AddPostPage';
import DoctorsPage from 'pages/DoctorsPage';
import CompanyActivationPage from 'pages/CompanyActivationPage';
import CompaniesPage from 'pages/CompaniesPage';
import AddCompanyPage from 'pages/AddCompanyPage';
import UpdateProfilePage from 'pages/UpdateProfilePage';
import RssFeedPage from 'pages/RssFeedPage';
import AddRssFeedPage from 'pages/AddRssFeedPage';
import ClosedCirclesPage from 'pages/ClosedCirclesPage';

const routes = {
  public: [
    {
      path: '/callback',
      component: <AuthenticationPage />,
    },
  ],
  private: [
    {
      path: '/posts',
      component: <PostsPage />,
    },
    {
      path: '/addPost',
      component: <AddPostPage />,
    },
    {
      path: '/doctors',
      component: <DoctorsPage />,
    },
    {
      path: '/companyActivation',
      component: <CompanyActivationPage />,
    },
    {
      path: '/companies',
      component: <CompaniesPage />,
    },
    {
      path: '/addCompany',
      component: <AddCompanyPage />,
    },
    {
      path: '/profile',
      component: <UpdateProfilePage />,
    },
    {
      path: '/rssFeed',
      component: <RssFeedPage />,
    },
    {
      path: '/addRssFeed',
      component: <AddRssFeedPage />,
    },
    {
      path: '/closedCircles',
      component: <ClosedCirclesPage />,
    },
  ],
};

export default routes;
